import DividedList from './DividedList'
import DividedListRow from './DividedListRow'

DividedList.Row = DividedListRow

export default DividedList
